import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-integrations-empty-state',
  standalone: true,
  imports: [ButtonModule, TranslateModule],
  templateUrl: './integrations-empty-state.component.html',
  styleUrls: ['./integrations-empty-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntegrationsEmptyStateComponent {
  @Output() public onClickSubmit$: EventEmitter<void> = new EventEmitter();
  @Input() public title: string;
}

